/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@libs/services/auth-strategy';

// @ts-ignore
import { ProgramActionResultMngDto } from '../model/programActionResultMngDto';
// @ts-ignore
import { ProgramCollectionMngDto } from '../model/programCollectionMngDto';
// @ts-ignore
import { ProgramExecuteActionMngDto } from '../model/programExecuteActionMngDto';
// @ts-ignore
import { ProgramMngDto } from '../model/programMngDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class ProgramManagementPMTService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy, // Inject the strategy if provided
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Executes an action on a specific program.
   * @param xTENANTID The tenant identifier (slug)
   * @param patientId The patient identifier.
   * @param programExecuteActionMngDto 
   */
  public async programManagementControllerExecuteProgramAction(xTENANTID: string, patientId: string, programExecuteActionMngDto: ProgramExecuteActionMngDto, ): Promise<ProgramActionResultMngDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programManagementControllerExecuteProgramAction.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling programManagementControllerExecuteProgramAction.');
    }
    if (programExecuteActionMngDto === null || programExecuteActionMngDto === undefined) {
      throw new Error('Required parameter programExecuteActionMngDto was null or undefined when calling programManagementControllerExecuteProgramAction.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/program-management/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/program-actions`,
        data: programExecuteActionMngDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * 
   * Gets the single program in the format suitable for PMT app.
   * @param xTENANTID The tenant identifier (slug)
   * @param patientId The patient identifier.
   * @param programId The program identifier.
   * @param periodId The period identifier.
   */
  public async programManagementControllerGetProgram(xTENANTID: string, patientId: string, programId: string, periodId?: string, ): Promise<ProgramMngDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programManagementControllerGetProgram.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling programManagementControllerGetProgram.');
    }
    if (programId === null || programId === undefined) {
      throw new Error('Required parameter programId was null or undefined when calling programManagementControllerGetProgram.');
    }

    let localVarQueryParameters: any = {};
    if (periodId !== undefined && periodId !== null) {
      localVarQueryParameters['periodId'] = periodId;
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/program/program-management/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/program/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        params: localVarQueryParameters,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Gets all programs related to the patient in the format suitable for PMT app.
   * @param xTENANTID The tenant identifier (slug)
   * @param patientId The patient identifier.
   */
  public async programManagementControllerGetPrograms(xTENANTID: string, patientId: string, ): Promise<ProgramCollectionMngDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programManagementControllerGetPrograms.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling programManagementControllerGetPrograms.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/program/program-management/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
